import * as actions from "./actionTypes";

const initialState = {
    opened: false,
    mobile: {
        counter: 0,
        selectedNumber: 0,
        show: false
    },
    workplace: {
        counter: 0,
        selectedNumber: 0,
        show: false
    },
    storage: {
        counter: 0,
        selectedNumber: 0,
        show: false
    },
    order: {
        OrderInventoryID: null,
        Generated: 0,
        ToGenerate: 0,
        show: false,
    },
    colli: {
        ColliInventoryID: null,
        Generated: 0,
        ToGenerate: 0,
        show: false,
    },
    transportColli: {
        TransportColliInventoryID: null,
        Generated: 0,
        ToGenerate: 0,
        show: false,
    },
    custom: {
        Generated: 0,
        ToGenerate: 0,
        show: false,
    }
}

const returnState = (typeState, payload, increment) => {
    const counter = increment ? ++typeState.counter : typeState.counter;
    const selectedNumber = payload?.selectedNumber ? typeState.selectedNumber + payload.selectedNumber : typeState.selectedNumber;
    return {
        selectedNumber,
        show: true,
        counter
    }
}

const resetStateType = () => {
    return {
        counter: 0,
        selectedNumber: 0,
        show: false
    }
}

const snackbarReducer = (state = initialState, action) => {
    const { mobile, workplace, storage, order, colli, transportColli, custom } = state;
    const type = action.payload?.type ? action.payload.type : null;
    const collection = action.payload?.collection ? action.payload.collection : null;

    switch (action.type) {
        case actions.SHOW:
            return {
                ...state,
                opened: true,
                [type]: returnState(state[type], action.payload, false)
            }
        case actions.SHOW_COLLECTION:
            return {
                ...state,
                opened: true,
                [type]: { ...collection, show: true }
            }
        case actions.HIDE_COLLECTION:
            return {
                ...state,
                opened: true,
                [type]: { ...collection, show: false }
            }
        case actions.INCREMENT_SNACKBAR_COUNTER:
            return {
                ...state,
                opened: true,
                [type]: returnState(state[type], action.payload, true)
            }
        case actions.RESET_SNACKBAR_COUNTER:
            if (state[type].selectedNumber === state[type].counter) {
                return {
                    ...state,
                    [type]: resetStateType()
                }
            }
            if (!mobile.show && !workplace.show && !storage.show && !order.show && !colli.show && !transportColli.show && !custom.show) {
                return {
                    ...state,
                    opened: false
                }
            }
            return state
        default:
            return state
    }
}

export default snackbarReducer;